import { render, staticRenderFns } from "./ChoosePin.vue?vue&type=template&id=7278e504&scoped=true"
import script from "./ChoosePin.vue?vue&type=script&lang=js"
export * from "./ChoosePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278e504",
  null
  
)

export default component.exports